import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export type ThemeMode = 'light' | 'dark';

export interface ThemePreferenceState {
    mode: ThemeMode;
}

const initialState: ThemePreferenceState = {
    mode: 'light'
};

const themePreferenceSlice = createSlice({
    name: 'themePreference',
    initialState,
    reducers: {
        setThemeMode: (state, action: PayloadAction<ThemeMode>) => {
            state.mode = action.payload;
        },
        toggleTheme: (state) => {
            state.mode = state.mode === 'light' ? 'dark' : 'light';
        }
    }
});

const themePreferenceConfig = {
    key: 'themePreference',
    storage
};

export const persistedThemePreferenceReducer = persistReducer(themePreferenceConfig, themePreferenceSlice.reducer);
export const { setThemeMode, toggleTheme } = themePreferenceSlice.actions;
export const themePreferenceReducer = themePreferenceSlice.reducer;
